import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCheckUserRole } from '../hooks/useCheckUserRole';
import Select from 'react-select';
import ThemeToggleButton from '../../components/ThemeToggleButton';



function AcilisOran() {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState(JSON.parse(localStorage.getItem('savedFilters')) || {});
    const [inputValues, setInputValues] = useState({});
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage] = useState(50);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [savedFilters, setSavedFilters] = useState([]); // Saved filters
    const [success, setSuccess] = useState(null);
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole')); // Kullanıcının rolünü al


    const [selectedFilter, setSelectedFilter] = useState(''); // Filtre dropdown'unun seçili değeri
    const [matchDates, setMatchDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [matches, setMatches] = useState([]);
    const [selectedMatch, setSelectedMatch] = useState('');
    const [sysMatchId, setSysMatchId] = useState(null);  // Seçilen maçın sys_match_id'sini tutacak state
    const [isDropdownClicked, setIsDropdownClicked] = useState(false);
    const [populateError, setPopulateError] = useState(null);
    const [populateSuccess, setPopulateSuccess] = useState(null);
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [hiddenHeaders, setHiddenHeaders] = useState([]);

    // Range Tolerance: { [colName]: { minus: 0.15, plus: 0.20 } }
    const [rangeTolerance, setRangeTolerance] = useState({});
    const [tolerancePopup, setTolerancePopup] = useState(null);
    const [toleranceInputs, setToleranceInputs] = useState({ minus: '', plus: '' });

    // Sayfa yüklendiğinde localStorage'dan gizlenen sütunları al
    useEffect(() => {
        const storedHiddenHeaders = localStorage.getItem('hiddenHeaders');
        if (storedHiddenHeaders) {
            setHiddenHeaders(JSON.parse(storedHiddenHeaders));
        }
    }, []);

    // Sütun gizleme/açma fonksiyonu
    const toggleHeaderVisibility = (header) => {
        let updatedHeaders;
        if (hiddenHeaders.includes(header)) {
            updatedHeaders = hiddenHeaders.filter(h => h !== header);
        } else {
            updatedHeaders = [...hiddenHeaders, header];
        }
        setHiddenHeaders(updatedHeaders);

        // Gizlenen sütunları localStorage'a kaydet
        localStorage.setItem('hiddenHeaders', JSON.stringify(updatedHeaders));
    };

    const navigate = useNavigate();

    const matchOptions = matches
        .filter(match => match.id) // sys_match_id olmayanları filtrele
        .map(match => ({
            value: match.id,
            label: `${match.league_code} | ${match.match_time} | ${match.home_team} - ${match.away_team}`,
        }));

    // Kullanıcı rolünü kontrol edin
    useCheckUserRole(['admin', 'editor', 'user', 'wait']);

    const columns = [
        {
            header: 'Maç Bilgileri',
            subColumns: [
                { header: 'Tarih', key: 'match_date' },
                { header: 'Lig', key: 'league_code' },
                { header: 'Maç Saati', key: 'match_time' },
                { header: 'MBS', key: 'mbs' },
                { header: 'Ev Sahibi ', key: 'home_team' },
                { header: 'Deplasman', key: 'away_team' },
            ]
        },
        {
            header: 'Maç Sonucu Skorları',
            subColumns: [
                { header: 'İlk Yarı Sonucu', key: 'half_time' },
                { header: 'Maç Sonucu', key: 'full_time' },
                //  { header: '1 İy Gol', key: 'home_ht_goal' },
                //  { header: '2 İy Gol', key: 'away_ht_goal' },
                //  { header: 'İlk Yarı', key: 'ht_result' },
                //  { header: '1 Ms Gol', key: 'home_ft_goal' },
                //  { header: '2 Ms Gol', key: 'away_ft_goal' },
                { header: 'Ms Kazanan', key: 'ft_result' },
                { header: 'Toplam Gol', key: 'total_goals' },
                { header: 'İlk Yarı / Ms Sonuç', key: 'ht_ft_result' },
            ]
        },
        {
            header: 'Maç Sonucu',
            subColumns: [
                { header: 'Kod', key: 'ft_odd_code' },
                { header: '1', key: 'ft_1_odd' },
                { header: '0', key: 'ft_x_odd' },
                { header: '2', key: 'ft_2_odd' },
            ]
        },
        {
            header: 'Handikaplı Ms',
            subColumns: [
                { header: 'Kod', key: 'hnd_odd_code' },
                { header: '1', key: 'hnd_1_odd' },
                { header: '0', key: 'hnd_x_odd' },
                { header: '2', key: 'hnd_2_odd' },
            ]
        },
        {
            header: 'İlk Golü Kim Atar',
            subColumns: [
                { header: 'Kod', key: 'fg_odd_code' },
                { header: '1 İlk Gol', key: 'fg_1_odd' },
                { header: 'Gol Olmaz', key: 'fg_no_odd' },
                { header: '2 İlk Gol', key: 'fg_2_odd' },
            ]
        },
        {
            header: 'Maç Sonucu ve Alt/Üst 2.5',
            subColumns: [
                { header: 'Kod', key: 'ms_and_25_odd_code' },
                { header: '1 / Alt', key: 'ms_1_and_u_25_odd' },
                { header: 'X / Alt', key: 'ms_x_and_u_25_odd' },
                { header: '2 / Alt', key: 'ms_2_and_u_25_odd' },
                { header: '1 / Üst', key: 'ms_1_and_o_25_odd' },
                { header: 'X / Üst', key: 'ms_x_and_o_25_odd' },
                { header: '2 / Üst', key: 'ms_2_and_o_25_odd' },
            ]
        },
        {
            header: 'Alt/Üst 2.5',
            subColumns: [
                { header: 'Kod', key: 'uo_25_odd_code' },
                { header: 'Alt', key: 'u_25_odd' },
                { header: 'Üst', key: 'o_25_odd' },
            ]
        },
        {
            header: 'Alt/Üst 3.5',
            subColumns: [
                { header: 'Kod', key: 'uo_35_odd_code' },
                { header: 'Alt', key: 'u_35_odd' },
                { header: 'Üst', key: 'o_35_odd' },
            ]
        },
        {
            header: 'Karşılıklı Gol',
            subColumns: [
                { header: 'Kod', key: 'btts_odd_code' },
                { header: 'Var', key: 'btts_yes_odd' },
                { header: 'Yok', key: 'btts_no_odd' },
            ]
        },
        {
            header: 'Toplam Gol Sayısı',
            subColumns: [
                { header: 'Kod', key: 'tgr_odd_code' },
                { header: '0-1', key: 'tgr_01_odd' },
                { header: '2-3', key: 'tgr_23_odd' },
                { header: '4-5', key: 'tgr_45_odd' },
                { header: '6+', key: 'tgr_6_odd' },
            ]
        },
        {
            header: 'İlk Yarı Sonucu',
            subColumns: [
                { header: 'Kod', key: 'ht_odd_code' },
                { header: '1', key: 'ht_1_odd' },
                { header: 'X', key: 'ht_x_odd' },
                { header: '2', key: 'ht_2_odd' },
            ]
        },
        {
            header: 'İlk Yarı 1.5 Alt/Üst',
            subColumns: [
                { header: 'Kod', key: 'ht_uo_15_odd_code' },
                { header: 'Alt', key: 'ht_u_15_odd' },
                { header: 'Üst', key: 'ht_o_15_odd' },
            ]
        },
        {
            header: 'İlk Yarı / Maç Sonucu',
            subColumns: [
                { header: 'Kod', key: 'htft_odd_code' },
                { header: '1 / Ms 1 ', key: 'htft_11_odd' },
                { header: '1 / Ms X ', key: 'htft_1x_odd' },
                { header: '1 / Ms 2 ', key: 'htft_12_odd' },

                { header: 'X / Ms 1', key: 'htft_x1_odd' },
                { header: 'X / Ms X', key: 'htft_xx_odd' },
                { header: 'X / Ms 2', key: 'htft_x2_odd' },

                { header: '2 / Ms 1', key: 'htft_21_odd' },
                { header: '2 / Ms X', key: 'htft_2x_odd' },
                { header: '2 / Ms 2', key: 'htft_22_odd' },
            ]
        },

    ];

    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);

        if (!storedIsLoggedIn) {
            navigate('/login');
        } else {
            fetchData();
        }
    }, [navigate, page, filters, rangeTolerance]);

    useEffect(() => {
        const filterType = 1;  // Acilisoran sayfası için filter_type 1

        fetch(`/api/get_filters?filter_type=${filterType}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            }
        })
            .then(response => response.json())
            .then(data => setSavedFilters(data))
            .catch(error => console.error('Filtreleme Hatası:', error));
    }, []);

    const saveFilter = () => {
        const filterName = prompt("Filtre İçin Ad Girin:");
        if (!filterName) return;

        const filterData = filters;  // Current filters
        const filterType = 1;  // Acilisoran sayfası için filter_type 1

        fetch('/api/save-filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ filter_name: filterName, filter_data: filterData, filter_type: filterType })
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(errorData.error || 'Filtre kaydetme başarısız');
                    });
                }
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    console.error('Filtre kaydetme başarısız:', data.error);
                    setError(data.error);
                } else {
                    console.log(data.message);
                    setSuccess(data.message);
                }
            })
            .catch(error => {
                console.error('Network hatası:', error);
                setError('Network hatası');
            });
    };

    const deleteFilter = (filterId) => {
        if (!window.confirm(`Bu filtreyi silmek istediğinize emin misiniz?`)) {
            return;
        }
    
        fetch('/api/delete-filter', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ id: filterId })
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(errorData.error || 'Filtre silme başarısız');
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log(data.message);
                setSavedFilters(prevFilters => prevFilters.filter(filter => filter.id !== filterId));
            })
            .catch(error => {
                console.error('Filtre Silinemedi:', error);
                setError('Filtre silme başarısız');
            });
    };
    


    const fetchData = () => {
        if (userRole === 'wait') {
            // Eğer kullanıcı 'wait' rolündeyse, veri getirme işlemini durdur
            return;
        }


        //const preparedFilters = {};
        //for (const key in filters) {
        //    preparedFilters[key] = `%${filters[key]}%`;
        //}

        setLoading(true);
        const params = new URLSearchParams({
            page,
            per_page: perPage,
        });

        // Apply filters with range tolerance support
        Object.keys(filters).forEach(key => {
            let val = filters[key];
            if (val && val.trim() !== '') {
                const tol = rangeTolerance[key];
                if (tol && (tol.minus > 0 || tol.plus > 0) && !isNaN(parseFloat(val))) {
                    const numVal = parseFloat(val);
                    params.append(key + '_min', (numVal - (tol.minus || 0)).toFixed(2));
                    params.append(key + '_max', (numVal + (tol.plus || 0)).toFixed(2));
                } else {
                    params.append(key, val);
                }
            }
        });

        const queryString = params.toString();

        fetch(`/api/bulten-data?${queryString}`)
            .then(response => response.json())
            .then(newData => {
                console.log(data);  // Gelen veriyi burada kontrol et
                if (page === 1) {
                    setData(newData.items || []);
                    setFilteredData(newData.items || []);
                } else {
                    setData(prevData => [...prevData, ...(newData.items || [])]);
                    setFilteredData(prevData => [...prevData, ...(newData.items || [])]);
                }
                setHasMore(newData.items.length === perPage);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    };


    const handleScroll = (e) => {
        if (window.innerHeight + e.target.documentElement.scrollTop + 1 >= e.target.documentElement.scrollHeight) {
            if (hasMore && !loading) {
                setPage(prevPage => prevPage + 1);
            }
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [hasMore, loading]);

    const handleFilterChange = (key, value) => {
        // Inputları güncelle (her durumda)
        setInputValues(prevInputValues => ({
            ...prevInputValues,
            [key]: value
        }));

        // Eğer değer boşsa filtreyi kaldır (temizle)
        if (value === '') {
            setFilters(prevFilters => {
                const newFilters = { ...prevFilters };
                delete newFilters[key];
                return newFilters;
            });
            setPage(1);
            return;
        }

        // Mevcut timeout'u temizleyelim
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        // Yeni bir timeout ayarlayalım (1000ms)
        const newTimeout = setTimeout(() => {
            // mbs için 1 karakter yeterli, diğerleri için en az 2 karakter gerekli
            const minLength = key === 'mbs' ? 1 : 2;
            if (value.length < minLength) {
                return;
            }

            // 3 karakter veya daha fazla olduğunda filtreyi uygula
            setFilters(prevFilters => ({
                ...prevFilters,
                [key]: value
            }));

            setPage(1); // Sayfa numarasını sıfırla
        }, 1000);

        // Yeni timeout'u kaydedelim
        setDebounceTimeout(newTimeout);
    };


    // --- Range Tolerance (±) ---
    const openTolerancePopup = (colName) => {
        if (tolerancePopup === colName) { setTolerancePopup(null); return; }
        const current = rangeTolerance[colName] || {};
        setToleranceInputs({ minus: current.minus || '', plus: current.plus || '' });
        setTolerancePopup(colName);
    };

    const applyTolerance = (colName) => {
        const minus = parseFloat(toleranceInputs.minus) || 0;
        const plus = parseFloat(toleranceInputs.plus) || 0;
        setRangeTolerance(prev => ({ ...prev, [colName]: { minus, plus } }));
        setTolerancePopup(null);
    };

    const clearTolerance = (colName) => {
        setRangeTolerance(prev => ({ ...prev, [colName]: { minus: 0, plus: 0 } }));
        setTolerancePopup(null);
    };

    const clearFilters = () => {
        setFilters({});
        setInputValues({});
        setPage(1);
        setSelectedDate(''); // Tarih dropdown'unu temizle
        setSelectedMatch(''); // Maç dropdown'unu temizle
        setSelectedFilter(''); // Filtre dropdown'unu temizle
    };

    useEffect(() => {
        if (Object.keys(filters).length === 0) {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item =>
                Object.keys(filters).every(key => {
                    const tol = rangeTolerance[key];
                    // If tolerance is active for this column, use numeric range check instead of string includes
                    if (tol && (tol.minus > 0 || tol.plus > 0) && !isNaN(parseFloat(filters[key]))) {
                        const itemVal = parseFloat(item[key]);
                        if (isNaN(itemVal)) return false;
                        const filterVal = parseFloat(filters[key]);
                        return itemVal >= (filterVal - tol.minus) && itemVal <= (filterVal + tol.plus);
                    }
                    return item[key]?.toString().toLowerCase().includes(filters[key].toLowerCase());
                })
            );
            setFilteredData(filtered);
        }
    }, [filters, data, rangeTolerance]);

    // Kaydedilmiş filtreyi uygula
    const applyFilter = (filterData) => {
        setFilters(filterData);
        setInputValues(filterData);  // Inputları da güncelle
        setPage(1);  // İlk sayfaya dön
    };



    // İlk Dropdown için: Bugün ve yarın tarihlerini almak
    const handleDropdownClick = () => {
        if (!isDropdownClicked) {
            fetch('/api/match-dates', {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then(response => response.json())
                .then(dates => {
                    // Gelen tarihleri "Bugün", "Yarın", "Ertesi Gün" olarak eşleştir
                    const labels = ["Bugün", "Yarın", "Ertesi Gün"];
                    const formattedDates = dates.map((date, index) => ({
                        value: date,
                        label: labels[index] || date, // Eğer fazla tarih gelirse fallback olarak tarihi göster
                    }));

                    setMatchDates(formattedDates);
                    setIsDropdownClicked(true); // Sadece bir kez çağrı yap
                })
                .catch(error => console.error('Tarih alımında hata:', error));
        }
    };

    // İkinci Dropdown: Seçilen tarihe göre maçları almak
    useEffect(() => {
        if (selectedDate) {
            fetch(`/api/matches-by-date?date=${selectedDate}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then(response => response.json())
                .then(matches => setMatches(matches))
                .catch(error => console.error('Maç alımında hata:', error));
        }
    }, [selectedDate]);


    // Populate Filter Fonksiyonu
    const populateFilter = async (filterName) => {
        if (!selectedMatch) {
            if (selectedDate) { // Tarih seçilmişse maç seçilmeli
                setPopulateError('Lütfen önce bir maç seçin.');
                return;
            }
            return; // Maç seçilmediği durumda hata vermesin
        }

        try {
            const response = await fetch('/api/populate-filter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    match_id: selectedMatch,
                    filter_name: filterName
                })
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || 'Filtre doldurulurken bir hata oluştu.');
            }

            // Doldurulmuş filtre verilerini uygulayın
            setFilters(result.populated_filter);
            setInputValues(result.populated_filter);
            setPage(1);
            setPopulateError(null);
        } catch (error) {
            console.error('Populate Filter Hatası:', error);
            setPopulateError(error.message);
        }
    };


    useEffect(() => {
        if (selectedMatch) {
            fetch(`/api/get-match-id?match_id=${selectedMatch}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.id) {
                        setSysMatchId(data.id);  // Update to set id instead of sys_match_id
                        console.log('Alınan id:', data.id);
                    } else {
                        console.error('Maç id alınamadı:', data.error);
                    }
                })
                .catch(error => console.error('id alma hatası:', error));
        }
    }, [selectedMatch]);

    useEffect(() => {
        if (selectedMatch && selectedFilter) {
            // Mevcut filtreyi yeniden uygula
            const selectedFilterData = savedFilters.find(filter => filter.filter_name === selectedFilter)?.filter_data;
            if (selectedFilterData) {
                applyFilter(selectedFilterData);
                populateFilter(selectedFilter);
            }
        }
    }, [selectedMatch]);


    const [darkTheme, setDarkTheme] = useState(false);

    // Tema durumunu `localStorage`'dan yükle
    useEffect(() => {
        const savedTheme = localStorage.getItem('darkTableTheme');
        if (savedTheme === 'true') {
            setDarkTheme(true);
            document.querySelector('.table-wrapper').classList.add('dark-theme');
        }
    }, []);

    const toggleTheme = () => {
        setDarkTheme((prevTheme) => {
            const newTheme = !prevTheme;
            const tableWrapper = document.querySelector('.table-wrapper');

            if (newTheme) {
                tableWrapper.classList.add('dark-theme');
                localStorage.setItem('darkTableTheme', 'true');
            } else {
                tableWrapper.classList.remove('dark-theme');
                localStorage.setItem('darkTableTheme', 'false');
            }

            return newTheme;
        });
    };


    return (
        <>
            {loading && <div className="loader">
                <div className="loader-inner">
                    <div className="circle"></div>
                </div>
            </div>}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="full-width">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p>Açılış Oranlar</p>
                                <h1>Tablosu</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {userRole === 'wait' ? (
                // Eğer kullanıcı 'wait' rolünde ise satın alma mesajı göster
                <div className="text-center">
                    <h2>Bu içeriği görüntüleyebilmek için üyelik satın almanız gerekmektedir.</h2>
                    <button className="btn btn-primary" onClick={() => navigate('/satinal')}>
                        Üyelik Satın Al
                    </button>
                </div>
            ) : (
                <div className="full-width filter">

                    <ThemeToggleButton />



                    <div className="row">
                        {/* Sol tarafta Kayıtlı Filtreler */}
                        <div className="col-lg-6">
                            <h3>Kayıtlı Filtreler</h3>

                            <div className="filter-container">
                                {/* Tarih Seçimi Dropdown */}
                                <select
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    onClick={handleDropdownClick}
                                    className="form-control filter-dropdown"
                                >
                                    <option value="">Tarih Seçin</option>
                                    {matchDates.map((item, index) => (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>

                                {/* Maç Seçimi Dropdown */}
                                {selectedDate && (
                                    <Select
                                        value={matchOptions.find(option => option.value === selectedMatch)}
                                        onChange={(selectedOption) => setSelectedMatch(selectedOption ? selectedOption.value : null)}
                                        options={matchOptions}
                                        placeholder="Maç Seçin"
                                        isSearchable
                                        classNamePrefix="filter-dropdown"
                                    />
                                )}

                                {/* Kaydedilmiş Filtreler */}
                                {!selectedDate && savedFilters.length > 0 && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <select
                                            className="form-control filter-dropdown"
                                            id="savedFilterDropdown"
                                            value={selectedFilter}
                                            onChange={(e) => {
                                                const selectedFilterName = e.target.value;
                                                setSelectedFilter(selectedFilterName);
                                                if (selectedFilterName) {
                                                    const selectedFilter = savedFilters.find(filter => filter.filter_name === selectedFilterName);
                                                    if (selectedFilter) {
                                                        applyFilter(selectedFilter.filter_data);
                                                        populateFilter(selectedFilterName);
                                                    }
                                                }
                                            }}
                                        >
                                            <option value="">Filtre Seçin</option>
                                            {savedFilters.map((filter, index) => (
                                                <option key={index} value={filter.filter_name}>
                                                    {filter.filter_name}
                                                </option>
                                            ))}
                                        </select>

                                        <button
    onClick={() => {
        const selectedFilterName = document.getElementById('savedFilterDropdown').value;
        const selectedFilter = savedFilters.find(f => f.filter_name === selectedFilterName);
        if (selectedFilter) {
            deleteFilter(selectedFilter.id);
        }
    }}
    className="btn btn-link delete-button"
>
    &times;
</button>

                                    </div>
                                )}

                                {/* Eğer tarih ve maç seçilmişse, Filtre Dropdown */}
                                {selectedDate && selectedMatch && savedFilters.length > 0 ? (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <select
                                            className="form-control filter-dropdown"
                                            id="savedFilterDropdown"
                                            value={selectedFilter}
                                            onChange={(e) => {
                                                const selectedFilterName = e.target.value;
                                                setSelectedFilter(selectedFilterName);
                                                if (selectedFilterName) {
                                                    const selectedFilter = savedFilters.find(filter => filter.filter_name === selectedFilterName);
                                                    if (selectedFilter) {
                                                        applyFilter(selectedFilter.filter_data);
                                                        populateFilter(selectedFilterName);
                                                    }
                                                }
                                            }}
                                        >
                                            <option value="">Filtre Seçin</option>
                                            {savedFilters.map((filter, index) => (
                                                <option key={index} value={filter.filter_name}>
                                                    {filter.filter_name}
                                                </option>
                                            ))}
                                        </select>

                                        <button
    onClick={() => {
        const selectedFilterName = document.getElementById('savedFilterDropdown').value;
        const selectedFilter = savedFilters.find(f => f.filter_name === selectedFilterName);
        if (selectedFilter) {
            deleteFilter(selectedFilter.id);
        }
    }}
    className="btn btn-link delete-button"
>
    &times;
</button>

                                    </div>
                                ) : null}

                                {!selectedDate && savedFilters.length === 0 && (
                                    <p className="no-filters-message">Henüz kayıtlı filtre yok</p>
                                )}


                            </div>
                            {hiddenHeaders.length > 0 && (
                                <div style={{ marginTop: '20px' }}>
                                    <h5>Gizlenen Sütunlar</h5>
                                    <div className="hidden-columns-container">
                                        {hiddenHeaders.map((header, index) => (
                                            <div key={index} className="hidden-column">
                                                <span>{header}</span>
                                                <button
                                                    onClick={() => toggleHeaderVisibility(header)}
                                                    className="restore-column-button"
                                                >
                                                    <i className="fas fa-check"></i> {/* Font Awesome checkmark */}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Populate Filter Mesajları */}
                            {populateError && <div className="alert alert-danger mt-2">Hata: {populateError}</div>}
                            {populateSuccess && <div className="alert alert-success mt-2">Başarı: {populateSuccess}</div>}
                        </div>

                        {/* Sağda Filtre Temizle ve Kaydet Butonları */}
                        <div className="col-lg-6 button-container">
                            <button onClick={clearFilters} className="btn btn-secondary">Filtreleri Temizle</button>
                            <button onClick={saveFilter} className="btn btn-primary">Filtreyi Kaydet</button>
                        </div>
                    </div>

                    {error && <div>Hata: {error}</div>}
                    {success && <div>Başarı: {success}</div>}

                    {/* Filtreleme tablosu */}
                    {!error && (
                        <div className="table-wrapper">
                            <table className="table">
                                <thead>
                                    <tr className="top-header">
                                        {columns.map((column, index) => (
                                            !hiddenHeaders.includes(column.header) && column.subColumns ? (
                                                <th colSpan={column.subColumns.length} key={index}>
                                                    <div className="column-header">
                                                        {column.header}
                                                        <input
                                                            type="checkbox"
                                                            checked={!hiddenHeaders.includes(column.header)}
                                                            onChange={() => toggleHeaderVisibility(column.header)}
                                                            className="column-header-checkbox"
                                                        />
                                                    </div>
                                                </th>
                                            ) : null
                                        ))}
                                    </tr>
                                    <tr>
                                        {columns.map((column, index) => (
                                            !hiddenHeaders.includes(column.header) && column.subColumns ? (
                                                column.subColumns.map(subColumn => (
                                                    <th key={subColumn.key} style={{ position: 'relative' }}>
                                                        <span
                                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                                            onClick={() => openTolerancePopup(subColumn.key)}
                                                            title="Tıklayarak tolerans ayarlayın"
                                                        >
                                                            {subColumn.header}
                                                            {rangeTolerance[subColumn.key] && (rangeTolerance[subColumn.key].minus > 0 || rangeTolerance[subColumn.key].plus > 0) && (
                                                                <sup style={{ fontSize: '7px', color: '#ff6b35', marginLeft: '1px', fontWeight: '800' }}>
                                                                    -{rangeTolerance[subColumn.key].minus}/+{rangeTolerance[subColumn.key].plus}
                                                                </sup>
                                                            )}
                                                        </span>
                                                        {tolerancePopup === subColumn.key && (
                                                            <div onClick={(e) => e.stopPropagation()} style={{
                                                                position: 'absolute',
                                                                top: '100%',
                                                                left: '50%',
                                                                transform: 'translateX(-50%)',
                                                                zIndex: 999,
                                                                background: '#1a1a1a',
                                                                border: '1px solid #ff6b35',
                                                                borderRadius: '8px',
                                                                padding: '8px',
                                                                width: '150px',
                                                                boxShadow: '0 4px 16px rgba(0,0,0,0.5)',
                                                                marginTop: '4px'
                                                            }}>
                                                                <div style={{ display: 'flex', gap: '6px', marginBottom: '6px' }}>
                                                                    <div style={{ flex: 1 }}>
                                                                        <div style={{ fontSize: '9px', color: '#ff6b35', fontWeight: '700', marginBottom: '3px', textAlign: 'center' }}>− Eksi</div>
                                                                        <input
                                                                            type="text"
                                                                            value={toleranceInputs.minus}
                                                                            onChange={(e) => setToleranceInputs(prev => ({ ...prev, minus: e.target.value }))}
                                                                            placeholder="0.15"
                                                                            style={{
                                                                                width: '100%',
                                                                                padding: '4px',
                                                                                fontSize: '11px',
                                                                                fontWeight: '600',
                                                                                textAlign: 'center',
                                                                                background: '#2d2d2d',
                                                                                border: '1px solid #444',
                                                                                borderRadius: '4px',
                                                                                color: '#fff',
                                                                                outline: 'none',
                                                                                boxSizing: 'border-box'
                                                                            }}
                                                                            onKeyDown={(e) => e.key === 'Enter' && applyTolerance(subColumn.key)}
                                                                        />
                                                                    </div>
                                                                    <div style={{ flex: 1 }}>
                                                                        <div style={{ fontSize: '9px', color: '#4CAF50', fontWeight: '700', marginBottom: '3px', textAlign: 'center' }}>+ Artı</div>
                                                                        <input
                                                                            type="text"
                                                                            value={toleranceInputs.plus}
                                                                            onChange={(e) => setToleranceInputs(prev => ({ ...prev, plus: e.target.value }))}
                                                                            placeholder="0.20"
                                                                            style={{
                                                                                width: '100%',
                                                                                padding: '4px',
                                                                                fontSize: '11px',
                                                                                fontWeight: '600',
                                                                                textAlign: 'center',
                                                                                background: '#2d2d2d',
                                                                                border: '1px solid #444',
                                                                                borderRadius: '4px',
                                                                                color: '#fff',
                                                                                outline: 'none',
                                                                                boxSizing: 'border-box'
                                                                            }}
                                                                            onKeyDown={(e) => e.key === 'Enter' && applyTolerance(subColumn.key)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <button
                                                                        onClick={() => applyTolerance(subColumn.key)}
                                                                        style={{
                                                                            flex: 1,
                                                                            padding: '4px',
                                                                            fontSize: '10px',
                                                                            fontWeight: '700',
                                                                            border: 'none',
                                                                            borderRadius: '4px',
                                                                            background: '#ff6b35',
                                                                            color: '#fff',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                    >Uygula</button>
                                                                    <button
                                                                        onClick={() => clearTolerance(subColumn.key)}
                                                                        style={{
                                                                            flex: 1,
                                                                            padding: '4px',
                                                                            fontSize: '10px',
                                                                            fontWeight: '700',
                                                                            border: '1px solid #444',
                                                                            borderRadius: '4px',
                                                                            background: '#2d2d2d',
                                                                            color: '#888',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                    >Kapat</button>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <input
                                                            type="text"
                                                            className="filter-input"
                                                            placeholder={`Filtre`}
                                                            value={inputValues[subColumn.key] || ''}
                                                            onChange={(e) => handleFilterChange(subColumn.key, e.target.value)}
                                                        />
                                                    </th>
                                                ))
                                            ) : null
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((item, index) => (
                                            <tr key={index}>
                                                {columns.map((column) => (
                                                    !hiddenHeaders.includes(column.header) && column.subColumns ? (
                                                        column.subColumns.map(subColumn => (
                                                            <td key={subColumn.key}>{item[subColumn.key]}</td>
                                                        ))
                                                    ) : null
                                                ))}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={columns.reduce((sum, column) => sum + (column.subColumns ? column.subColumns.length : 1), 0)}>Veri bulunamadı</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

            )}
        </>
    );
}
export default AcilisOran;
